import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, EventEmitter, HostBinding, HostListener, Input, Output, inject } from '@angular/core';
import { ILink } from '../_shared/models/link.model';
import { IconComponent } from '../icon/icon.component';

import { IconName } from '../_shared/models/icon.model';

@Component({
    selector: 'sirius-overlay-menu',
    templateUrl: './overlay-menu.component.html',
    styleUrls: ['./overlay-menu.component.scss'],
    host: { class: 'sir-text-style-paragraph-m-default' },
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IconComponent]
})
export class OverlayMenuComponent implements AfterViewInit {
    private _el = inject(ElementRef);

    @Input() options?: { icon: IconName; link: ILink }[];

    @Output() clickEvent = new EventEmitter<MouseEvent>();
    @Output() closeEvent = new EventEmitter<Event>();

    @HostBinding('tabindex')
    tabindex = 0;

    @HostBinding('id')
    @Input()
    id = '';

    @HostBinding('attr.aria-labelledby')
    @Input()
    labelledby = '';

    @HostBinding('attr.role')
    role = 'menu';

    @HostListener('click', ['$event'])
    onClick(e: MouseEvent): void {
        e.stopPropagation();

        const button = e.target as HTMLButtonElement;
        if (!button) return;

        this.clickEvent.emit(e);
    }

    @HostListener('focusout', ['$event'])
    onBlur(e: FocusEvent): void {
        const relatedTarget = e.relatedTarget as HTMLElement;
        if (relatedTarget !== null && this._el.nativeElement.contains(relatedTarget)) return;

        this.closeEvent.emit(e);
    }

    @HostListener('document:keydown', ['$event'])
    handleKeyboardEvent(e: KeyboardEvent) {
        switch (e.key) {
            case 'Escape':
                this.closeEvent.emit(e);
                break;
            case 'ArrowDown':
                e.preventDefault();
                this._handleArrowDown();
                break;
            case 'ArrowUp':
                e.preventDefault();
                this._handleArrowUp();
                break;
        }
    }

    ngAfterViewInit(): void {
        this._el.nativeElement.focus();
    }

    get _isNavtiveElementActive(): boolean {
        return (
            this._el.nativeElement.ownerDocument?.activeElement.tagName ===
            this._el.nativeElement.tagName
        );
    }

    _focusFirstOption(): void {
        this._el.nativeElement.querySelector('a').focus();
    }

    _focusNextOption(): void {
        const _next = this._el.nativeElement.ownerDocument.activeElement.parentElement.nextSibling;
        if (_next.tagName) _next.querySelector('a').focus();
    }

    _focusPreviousOption(): void {
        const _previous =
            this._el.nativeElement.ownerDocument.activeElement.parentElement.previousSibling;
        if (_previous) _previous.querySelector('a').focus();
    }

    _handleArrowDown(): void {
        if (this._isNavtiveElementActive) {
            this._focusFirstOption();
        } else {
            this._focusNextOption();
        }
    }

    _handleArrowUp(): void {
        if (this._isNavtiveElementActive) {
            this._focusFirstOption();
        } else {
            this._focusPreviousOption();
        }
    }
}
